import { Button, Card, Col, Layout, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useState } from "react";
import CONSTANTS from "constants/constants";
import dvtHero from "assets/dvt_hero.svg";
import offerRealtime from "assets/offer_realtime.svg";
import supportDecision from "assets/support_decision.svg";
import "components/OurServices/style.css";
import { CheckCircleFilled } from "@ant-design/icons";
import dvtBenefits1 from "assets/dvt_benefits1.svg";
import dvtBenefits2 from "assets/dvt_benefits2.svg";
import dvtBenefits3 from "assets/dvt_benefits3.svg";
import dvtBenefits4 from "assets/dvt_benefits4.svg";
import dvtBenefits5 from "assets/dvt_benefits5.svg";
import dvtBenefits6 from "assets/dvt_benefits6.svg";
import DVTDemoVideo from "assets/videos/DVT.mp4";
import { WatchVideoIcon } from "common/icons";
import DemoVideoModal from "common/DemoVideoModal";

const Dvt = () => {
  const [demoVideoModal, setDemoVideoModal] = useState(false);
  const { DVT } = CONSTANTS;
  const { Meta } = Card;
  const dvtBenefits = [
    {
      title: DVT.DVT_BENEFITS1.TITLE,
      description: DVT.DVT_BENEFITS1.DESCRIPTION,
      image: dvtBenefits1,
    },
    {
      title: DVT.DVT_BENEFITS2.TITLE,
      description: DVT.DVT_BENEFITS2.DESCRIPTION,
      image: dvtBenefits2,
    },
    {
      title: DVT.DVT_BENEFITS3.TITLE,
      description: DVT.DVT_BENEFITS3.DESCRIPTION,
      image: dvtBenefits3,
    },
    {
      title: DVT.DVT_BENEFITS4.TITLE,
      description: DVT.DVT_BENEFITS4.DESCRIPTION,
      image: dvtBenefits4,
    },
    {
      title: DVT.DVT_BENEFITS5.TITLE,
      description: DVT.DVT_BENEFITS5.DESCRIPTION,
      image: dvtBenefits5,
    },
    {
      title: DVT.DVT_BENEFITS6.TITLE,
      description: DVT.DVT_BENEFITS6.DESCRIPTION,
      image: dvtBenefits6,
    },
  ];
  return (
    <Layout>
      <Content>
        {demoVideoModal && (
          <DemoVideoModal
            demoVideoModal={demoVideoModal}
            onChangeDemoVideo={(view) => setDemoVideoModal(view)}
            demoVideo={DVTDemoVideo}
          />
        )}
        <Row
          className="dvt-section pr4 pl4 pb2 pt2 dvt-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={12}>
            <p className="dvt-section-header mt1">
              <span className="dvt-special-text">DVT</span>
            </p>
            <p className="dvt-section-text">
              {DVT.DVT_MAIN.LINE_1}
              <span className="dvt-special-text dvt-section-side-header">
                {DVT.DVT_MAIN.LINE_2}
              </span>
              {DVT.DVT_MAIN.LINE_3}
              <span className="dvt-special-text dvt-section-side-header">
                {DVT.DVT_MAIN.LINE_4}
              </span>
              {DVT.DVT_MAIN.LINE_5}
            </p>
            <Button
              className="watch-button mt1"
              onClick={() => setDemoVideoModal(true)}
            >
              <WatchVideoIcon className="watch-button-icon" />
              <span className="ml1">Quick Tour</span>
            </Button>
          </Col>
          <Col lg={12} className="flex-center">
            <img src={dvtHero} className="dvt-image" alt="dvt hero" />
          </Col>
        </Row>
        <Row
          className="pr4 pl4 pb2 pt2 dvt-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={{ span: 12, order: 2 }} md={{ order: 1 }}>
            <p className="dvt-section-header-two mt1">
              <span className="dvt-special-text">Real-Time</span> Insights
            </p>
            <div className="dvt-section-text">
              {[
                DVT.REALTIME_INSIGHTS_1,
                DVT.REALTIME_INSIGHTS_2,
                DVT.REALTIME_INSIGHTS_3,
              ].map((item, index) => (
                <div key={index} className="prodred-check-icons">
                  <p>
                    <span className="dvt-circle-filled">
                      <CheckCircleFilled />
                    </span>
                    <span className="dvt-special-text dvt-section-side-header">
                      {item.KEY}
                    </span>
                    <span className="dvt-section-side-value">{item.VALUE}</span>
                  </p>
                </div>
              ))}
            </div>
          </Col>
          <Col
            lg={{ span: 12, order: 1 }}
            md={{ order: 2 }}
            className="flex-center"
          >
            <img
              src={offerRealtime}
              className="dvt-image"
              alt="dvt realtime insights"
            />
          </Col>
        </Row>
        <Row
          className="pr4 pl4 pb2 pt2 dvt-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={12}>
            <p className="dvt-section-header-two mt1">
              <span className="dvt-special-text">Data </span>Analytics
            </p>
            <div className="dvt-section-text">
              {[
                DVT.DATA_ANALYTICS_1,
                DVT.DATA_ANALYTICS_2,
                DVT.DATA_ANALYTICS_3,
              ].map((item, index) => (
                <div key={index} className="prodred-check-icons">
                  <p>
                    <span className="dvt-circle-filled">
                      <CheckCircleFilled />
                    </span>
                    <span className="dvt-special-text dvt-section-side-header">
                      {item.KEY}
                    </span>
                    <span className="dvt-section-side-value">{item.VALUE}</span>
                  </p>
                </div>
              ))}
            </div>
          </Col>
          <Col lg={12} className="flex-center">
            <img
              src={supportDecision}
              className="dvt-image"
              alt="dvt support decison making"
            />
          </Col>
        </Row>
        <Row className="pr5 pl5 pb2 pt2 dvt-main dvt-section">
          <Col>
            <Row justify="space-around" align="middle" className="mb2">
              <Col>
                <p className="dvt-section-header-two mt1">
                  <span className="dvt-special-text">
                    {DVT.DVT_BENEFITS_HEADER1}
                  </span>
                  {DVT.DVT_BENEFITS_HEADER2}
                </p>
              </Col>
            </Row>
            <Row gutter={[24, 24]} className="mb2">
              {dvtBenefits.map((item, index) => (
                <Col lg={8} sm={12} xs={24}>
                  <Card
                    index={index}
                    hoverable
                    className="dvt-benefits-card"
                    cover={
                      <img
                        src={item.image}
                        alt={item.title}
                        className="dvt-benefits-image"
                      />
                    }
                  >
                    <Meta title={item.title} description={item.description} />
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Dvt;
